<div class="col-sm-2 daily-reports-filter">
    <div class="daily-reports-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="daily-reports-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="draftCheckbox" #draftCheckbox (change)="changeFilter()">
                <label for="draftCheckbox"><svg-checked></svg-checked></label>
                <span>Draft</span>
            </label>
        </div>
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="closedCheckbox" #closedCheckbox (change)="changeFilter()">
                <label for="closedCheckbox"><svg-checked></svg-checked></label>
                <span>Closed</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox directory-add-modal-date-field">
            <label>Start Date</label>
            <mat-form-field (click)="startPicker.open()">
                <input matInput [(ngModel)]="startDate" name="startDate" [matDatepicker]="startPicker" disabled
                       (focus)="startPicker.open()" (click)="startPicker.open()"
                       (ngModelChange)="onStartDateChange()" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="m-b-xs filter-checkbox directory-add-modal-date-field">
            <label>End Date</label>
            <mat-form-field (click)="endPicker.open()">
                <input matInput [(ngModel)]="endDate" name="endDate" disabled
                       [matDatepicker]="endPicker" [min]="startDate"
                       (focus)="endPicker.open()" (click)="endPicker.open()" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="row text-center buttons-row">
            <button class="btn btn-primary" [disabled]="!startDate && !endDate" (click)="changeFilter()">
                Apply
            </button>

            <button class="btn btn-primary" *ngIf="startDate || endDate" (click)="clearDates()">
                Clear
            </button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/daily-reports-filter/daily-reports-filter.component.html